import { useEffect, useState } from "react";
import { Column, GridView, Griew, Response } from "react-griew";
import i18n from "../../plugins/locale/i18n";
import loadDictionary from "../../plugins/locale/load-dictionary";
import UserService from "../../service/user-service";
import Pasoonate from "pasoonate";
import CreateUserWindow from "./CreateUserWindow";
import EditUserWindow from "./EditUserWindow";
import ResetUserPasswordWindow from "./ResetUserPasswordWindow";

const userService = new UserService();
const griew = new Griew();

await loadDictionary('user-main-page');

function UserMainPage() {
  const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenCreateWindow, setIsOpenCreateWindow] = useState(false);
  const [isOpenEditWindow, setIsOpenEditWindow] = useState(false);
  const [isOpenResetPasswordWindow, setIsOpenResetPasswordWindow] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const reloadList = () => { 
    setIsLoading(true); 
    griew.refresh();
  };
  const handleOpenCreateWindow = () => {
    setIsOpenCreateWindow(true);  
  };
  const handleCloseCreateWindow = () => {
    setIsOpenCreateWindow(false);
    reloadList();
  };
  const handleOpenEditWindow = (userId) => {
    setSelectedUserId(userId);
    setIsOpenEditWindow(true);  
  };
  const handleCloseEditWindow = () => {
    setSelectedUserId(null);
    setIsOpenEditWindow(false);
    reloadList();
  };
  const handleOpenResetPasswordWindow = (userId) => {
    setSelectedUserId(userId);
    setIsOpenResetPasswordWindow(true);  
  };
  const handleCloseResetPasswordWindow = () => {
    setSelectedUserId(null);
    setIsOpenResetPasswordWindow(false);  
  };

  useEffect(() => {
    prepareGriew(setCount, setIsLoading, handleOpenEditWindow, handleOpenResetPasswordWindow);
    reloadList();
  }, []);

  return (
    <div className="page">
      <div className="page-header bg-body p-3">
        <h4 className="page-title">{i18n.t("user-main-page.page_title")}</h4>
        <div className="header-content"></div>
      </div>
      <div className="content-area bg-body-tertiary p-3">
        <div className="row mb-2">
          <div className="table-title col">
            <h5 className="mt-1 mb-3">{i18n.t("user-main-page.table_title")} ({count})</h5>
          </div>
          <div className="table-toolbar col-auto">
            <button className="btn btn-sm btn-primary me-2 mb-2" type="button" onClick={handleOpenCreateWindow}>{i18n.t("user-main-page.new_button")}</button>
            <button className={"btn btn-sm btn-light mb-2 " + (isLoading ? 'rotate' : '')} type="button" onClick={reloadList}><i className="bi bi-arrow-clockwise"></i></button>
          </div>
        </div>
        <div className="table-responsive">
          <GridView griew={griew} ></GridView>
        </div>
      </div>
      <CreateUserWindow key={`create-${Date.now()}`} isOpenWindow={isOpenCreateWindow} onCloseWindow={handleCloseCreateWindow} />
      <EditUserWindow key={`edit-${selectedUserId}`} isOpenWindow={isOpenEditWindow} onCloseWindow={handleCloseEditWindow} userId={selectedUserId} />
      <ResetUserPasswordWindow key={`reset-${selectedUserId}`} isOpenWindow={isOpenResetPasswordWindow} onCloseWindow={handleCloseResetPasswordWindow} userId={selectedUserId} />
    </div>
  );
}

const prepareGriew = (setCount, setIsLoading, handleOpenEditWindow, handleOpenResetPasswordWindow) => {
    const list = [
      {
        name: "id",
        caption: "کد",
        schema: "َUser",
        type: Column.NUMBER,
        order: 1,
        sortable: false,
        filterable: false,
        visibility: true,
      },
      {
        name: "role_id",
        caption: "کد نقش",
        schema: "َUser",
        type: Column.NUMBER,
        order: 1,
        sortable: false,
        filterable: false,
        visibility: false,
      },
      {
        name: "name",
        caption: "نام",
        schema: "User",
        type: Column.STRING,
        order: 2,
        sortable: false,
        filterable: false,
        visibility: true,
      },
      {
        name: "mobile",
        caption: "موبایل",
        schema: "User",
        type: Column.STRING,
        order: 3,
        sortable: false,
        filterable: false,
        visibility: true,
      },
      {
        name: "is_active",
        caption: "وضعیت",
        schema: "User",
        type: Column.BOOLEAN,
        order: 4,
        sortable: false,
        filterable: false,
        visibility: true,
        beforeRender: (value) => { 
          return value ? "فعال" : "غیرفعال";
        }
      },
      {
        name: "created_at",
        caption: "تاریخ ایجاد",
        schema: "User",
        type: Column.DATETIME,
        order: 5,
        sortable: false,
        filterable: false,
        visibility: true,
        beforeRender: (value) => { 
          const createdAt = Pasoonate.make().gregorian().parse('yyyy-MM-dd HH:mm:ss', value).jalali().format("yy/MM/dd HH:mm");
    
          return <span dir="ltr">{createdAt}</span>;
        },
      },
      {
        name: "",
        caption: "عملیات",
        schema: "",
        type: Column.STRING,
        order: 6,
        sortable: false,
        filterable: false,
        visibility: true,
        beforeRender: (value, user) => { 
          const editButton = user.deleted_at ? '' : <button type="button" className="btn btn-sm btn-light" onClick={() => { handleOpenEditWindow(user.id) }}>{i18n.t("user-main-page.edit_button")}</button>;
          const resetPasswordButton = user.deleted_at && !user.is_active ? '' : <button type="button" className="btn btn-sm btn-light ms-1" onClick={() => { handleOpenResetPasswordWindow(user.id) }}>{i18n.t("user-main-page.reset_password_button")}</button>;
          // const removeButton = user.deleted_at ? '' : <button type="button" className="btn btn-sm btn-light ms-1" onClick={() => { setRemoveUserId(party.id) }}>{i18n.t("party.main_page.remove_button")}</button>;

          return (
            <>
            {editButton}          
            {resetPasswordButton}
            </>
          );
        }
      }
    ];
    const callback = (promis) => {
      promis.then(response => {
        const pagination = response.pagination;
        const data = response.data;

        const res = Response.make({
          data: data,
          pagination: {
            currentPage: pagination?.currentPage ?? 1,
            lastPage: pagination?.lastPage ?? 1,
            perPage: pagination?.perPage ?? 15,
            total: pagination?.total ?? 1,
            from: pagination?.from ?? 1,
            to: pagination?.to ?? 1,
          }
        });

        griew.refresh(res);

        setCount(pagination.total);

        setIsLoading(false);
      })
      .catch(error => {
        console.log(error);
      });
    };

    griew.localization.locale = 'fa';
    griew.columns.fromArray(list);
    griew.providers.default = 'function';
    griew.providers.getProvider().options = {
        function: (query) => userService.gridview(query),
        callback: callback
    };
  };

export default UserMainPage;